module.exports = __webpack_public_path__ + "static/img/sidebar-logo-ar.ea19f46a.svg";